import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { DownloadService } from 'src/app/shared/services/download.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-download-edit',
  templateUrl: './download-edit.component.html',
  styleUrls: ['./download-edit.component.css']
})
export class DownloadEditComponent implements OnInit {
  dialogData :any;
  constructor(
    public service : DownloadService,
   // private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private dialogRef: MatDialogRef<DownloadEditComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

      console.log("DownloadEditComponent");
      this.dialogData = data;
   }

  ngOnInit() {
    console.log("ngOnInit");
  }

  onClose() {
    this.service.form.reset();
    this.service.initializeFormGroup(null, null, null);
    this.dialogRef.close();
  }

  onSubmit() {
    console.log("Create product");

    if (this.service.form.valid)
    {
      if (this.service.form.get('fileId').value){ //update
        this.service.updateData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submit successfuly", "Download Modify");
            this.gnotify.showSnackBar('Download Modify', 'Submit successfuly', "success");
            this.dialogData.result = true;
            this.onClose();
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Download Modify");
            this.gnotify.showSnackBar('Download Modify', 'Failed to Submit', "error");
            return;
          }
        );
      }
      else{ // new
        this.service.insertData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submit successfuly", "Download Created");
            this.gnotify.showSnackBar('Download Created', 'Submit successfuly', "success");
            this.dialogData.result = true;
            this.onClose();
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Download Created");
            this.gnotify.showSnackBar('Download Created', 'Failed to Submit', "error");
            return;
          }
        );

      }
    }
    else{ // invalid
     //// this.toastr.error("Failed to Submit", "Data invalid");
     this.gnotify.showSnackBar('Data invalid', 'Failed to Submit', "error");
    }

  }


}
